(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
  const initProductGalleryAspect = (scope = document) => {
    scope.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
      if (gallery.dataset.galleryAspectReady === 'true') return;

      const media = gallery.closest('.product-media');
      const slides = Array.from(gallery.querySelectorAll('[data-gallery-slide]'));
      if (!media || slides.length === 0) return;

      const updateAspect = () => {
        const activeSlide = slides.find((slide) => slide.classList.contains('is-active') && !slide.hidden) || slides[0];
        const aspect = Number(activeSlide.dataset.galleryAspect || 1);
        if (Number.isFinite(aspect) && aspect > 0) {
          media.style.setProperty('--sm-product-media-aspect', String(aspect));
        }
      };

      const observer = new MutationObserver(updateAspect);
      slides.forEach((slide) => observer.observe(slide, { attributes: true, attributeFilter: ['class', 'hidden'] }));
      updateAspect();
      gallery.dataset.galleryAspectReady = 'true';
    });
  };

  const initProductVariantPrices = (scope = document) => {
    scope.querySelectorAll('.product-page').forEach((page) => {
      if (page.dataset.variantPriceReady === 'true') return;

      const select = page.querySelector('form[action*="/cart/add"] select[name="id"]');
      const price = page.querySelector('[data-product-price]');
      if (!select || !price) return;

      const updatePrice = () => {
        const selectedOption = select.options[select.selectedIndex];
        if (selectedOption?.dataset.price) price.textContent = selectedOption.dataset.price;
        const soldOut = selectedOption?.dataset.smSoldOut === 'true';
        page.classList.toggle('sm-is-sold-out', soldOut);
        const badge = page.querySelector('[data-sm-product-stock]');
        const submit = page.querySelector('[data-sm-stock-submit]');
        if (badge) badge.hidden = !soldOut;
        if (submit) {
          submit.disabled = soldOut;
          submit.textContent = soldOut ? submit.dataset.smSoldOutLabel : submit.dataset.smAddLabel;
        }
      };

      select.addEventListener('change', updatePrice);
      updatePrice();
      page.dataset.variantPriceReady = 'true';
    });
  };

  const initProductReviewRatings = (scope = document) => {
    scope.querySelectorAll('[data-sm-product-review]').forEach((review) => {
      if (review.dataset.ratingReady === 'true') return;

      const input = review.querySelector('input[name="contact[Rating]"]');
      const stars = Array.from(review.querySelectorAll('[data-sm-review-star]'));
      if (!input || stars.length === 0) return;

      const setRating = (rating) => {
        input.value = String(rating);
        stars.forEach((star) => {
          const value = Number(star.dataset.rating);
          star.classList.toggle('is-active', value <= rating);
          star.setAttribute('aria-checked', value === rating ? 'true' : 'false');
        });
      };

      stars.forEach((star) => {
        star.addEventListener('click', () => setRating(Number(star.dataset.rating) || 5));
      });

      setRating(Number(input.value) || 5);
      review.dataset.ratingReady = 'true';
    });

    scope.querySelector('[data-sm-review-success]')?.focus({ preventScroll: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initProductGalleryAspect();
      initProductVariantPrices();
      initProductReviewRatings();
    }, { once: true });
  } else {
    initProductGalleryAspect();
    initProductVariantPrices();
    initProductReviewRatings();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initProductGalleryAspect(event.target);
    initProductVariantPrices(event.target);
    initProductReviewRatings(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["saintmagic-cart-widget"]) return;
  try {
    
(() => {
  const formatMoney = (cents, currency) => {
    const amount = (Number(cents) || 0) / 100;
    try {
      return new Intl.NumberFormat(document.documentElement.lang || "en-US", {
        style: "currency",
        currency: currency || window.Shopify?.currency?.active || "USD"
      }).format(amount);
    } catch (error) {
      return `$${amount.toFixed(2)}`;
    }
  };

  const updateCartWidget = (widget, cart) => {
    const itemCount = Number(cart.item_count || 0);
    const total = formatMoney(cart.total_price, cart.currency);
    const count = widget.querySelector("[data-cart-count]");
    const totalNode = widget.querySelector("[data-cart-total]");
    if (count) count.textContent = String(itemCount);
    if (totalNode) totalNode.textContent = total;
    const cartOpenLabel = widget.dataset.cartOpenLabel || "Open cart";
    const cartItemsLabel = widget.dataset.cartItemsLabel || " items";
    widget.setAttribute("aria-label", `${cartOpenLabel}: ${itemCount}${cartItemsLabel}, ${total}`);
  };

  const refreshCartWidgets = () => {
    const widgets = Array.from(document.querySelectorAll("[data-cart-widget]"));
    if (!widgets.length) return;
    const root = window.Shopify?.routes?.root || "/";
    window.fetch(`${root}cart.js`, { credentials: "same-origin" })
      .then((response) => {
        if (!response.ok) throw new Error("Cart request failed");
        return response.json();
      })
      .then((cart) => {
        widgets.forEach((widget) => updateCartWidget(widget, cart));
      })
      .catch(() => {
      });
  };

  const scheduleRefresh = () => {
    window.setTimeout(refreshCartWidgets, 450);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", refreshCartWidgets);
  } else {
    refreshCartWidgets();
  }

  window.addEventListener("pageshow", refreshCartWidgets);
  document.addEventListener("cart:refresh", refreshCartWidgets);
  document.addEventListener("saintmagic:cart-refresh", refreshCartWidgets);

  document.addEventListener("submit", (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if ((form.getAttribute("action") || "").includes("/cart/add")) scheduleRefresh();
  });

  if (!window.__saintmagicCartFetchPatched) {
    const nativeFetch = window.fetch;
    window.fetch = function patchedFetch(...args) {
      const request = args[0];
      const url = typeof request === "string" ? request : request?.url || "";
      const response = nativeFetch.apply(this, args);
      if (/\/cart\/(add|change|update|clear)(\.js)?/.test(url)) {
        response.then(scheduleRefresh).catch(() => {
        });
      }
      return response;
    };
    window.__saintmagicCartFetchPatched = true;
  }
})();

  } catch(e) { console.error(e); }
})();
})();
